/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 2 = ReceivedFrom
 *
 * 3 = LeadSendTo
 *
 * 4 = LeadReceivedFrom
 *
 * 5 = SvcEvalSendTo
 *
 * 6 = VipPhonecall
 *
 * 19 = EnquiryCrm
 *
 * 21 = HandoverFollowUp
 *
 * 22 = Sorder
 *
 * 25 = SoHeader
 */
export enum SmsTaskEnum {
  ReceivedFrom = 2,
  LeadSendTo = 3,
  LeadReceivedFrom = 4,
  SvcEvalSendTo = 5,
  VipPhonecall = 6,
  EnquiryCrm = 19,
  HandoverFollowUp = 21,
  Sorder = 22,
  SoHeader = 25,
}
